import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, type CanActivate, type GuardResult, RouterStateSnapshot } from '@angular/router';
import { UserService } from '../state/user.service';

@Injectable({ providedIn: 'any' })
export class UserAuthenticatedGuard implements CanActivate {
    private readonly userService = inject(UserService);

    public async canActivate(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<GuardResult> {
        await this.userService.initializeAuthentication(); // Make sure it is initialized

        if (this.userService.isAuthenticated()) {
            return true;
        }

        try {
            const newUrl = new URL(state.url, 'http://localhost');
            const destination = newUrl.searchParams.get('destination') ?? state.url;

            return this.userService.login(destination) ?? false;
        } catch (e: unknown) {
            // eslint-disable-next-line no-console
            console.error(e);
        }

        return false;
    }
}
